import { render, staticRenderFns } from "./SummaryBoxInitial.vue?vue&type=template&id=4350b7aa&scoped=true&"
import script from "./SummaryBoxInitial.vue?vue&type=script&lang=js&"
export * from "./SummaryBoxInitial.vue?vue&type=script&lang=js&"
import style0 from "./SummaryBoxInitial.vue?vue&type=style&index=0&id=4350b7aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4350b7aa",
  null
  
)

export default component.exports